module.exports = __webpack_public_path__ + "img/34.013c83b3.jpg";